import React, { useState } from 'react';
import '../style/Forms.scss';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { API_BASE_URL } from '../config';
import user from '../Assets/user.png';
import pass from '../Assets/padlock.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthContext';

const Login = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
      username: '',
      password: '',
    });
    const [error, setError] = useState('');
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        setLoading(true);
        const baseUrl = API_BASE_URL || '';
        const response = await axios.post(`${baseUrl}/api/login`, formData);
        if (response.data.message === 'Logged In Successfully') {
          const { token, username } = response.data;
          localStorage.setItem('username', username);
          // Update AuthContext state synchronously before navigation
          login(token);
          toast.success('Logged In Successfully');
          // Navigate after state is updated
          navigate('/mainpage');
        } else {
          setError(response.data.message);
          toast.error(response.data.message);
        }
      } catch (error) {
        console.error(error);
        toast.error('Server Error');
      } finally {
        setLoading(false);
      }
    };
    
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };
    
  
    return (
      <div className='login-page'>
        <ToastContainer position='top-center' />
        <div className='heading'>
          <h1> Login </h1>
        </div>
        <div className='form-container'>
          {error && <div className='error-message'>{error}</div>}
          <form onSubmit={handleSubmit} className='form'>
            <label>
              {' '}
              <img src={user} alt='error' className='logo1' /> Username:{' '}
            </label>
            <input
             type='text'
             name='username'
             value={formData.username} 
             onChange={handleChange}
             placeholder='Enter your Username here'
             />
            <label>
              <img src={pass} alt='error' className='logo3' /> Password:
            </label>
            <div className='password-input'><input
             type= {showPassword ? 'text' : 'password'} 
             name='password' 
             value={formData.password} 
             onChange={handleChange}
             placeholder='Enter your Password here'
            />
            <Link onClick={togglePasswordVisibility} className='eye-icon'>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </Link></div>
            

            <button type='submit' disabled={loading}>
              {loading ? 'Logging ...' : 'Login'}
            </button>
          </form>
        </div>
        <div className='disclaimer'>
          <p style={{ fontSize: 20 }}>
            <strong> Disclaimer: </strong>
          </p>
          <p>
            By logging into this app, you agree to abide by our terms of service and acknowledge that the app collects
            and securely stores your login information for authentication purposes only. Your privacy and data security
            are our top priorities.
          </p>
        </div>
      </div>
    );
  };
  
  export default Login;
  